import { z } from "zod";

export const RehearsalSessionStatusSchema = z.enum([
  "planned",
  "completed",
  "cancelled",
]);
export type RehearsalSessionStatus = z.infer<
  typeof RehearsalSessionStatusSchema
>;

export const RehearsalStudioBookingSchema = z.object({
  roomId: z.string().min(1),
  startTime: z.string().min(1),
  endTime: z.string().min(1),
  chargeType: z.enum(["free", "paid"]).default("free"),
  amount: z.number().int().min(0).optional(),
  bookingNotes: z.string().optional(),
});
export type RehearsalStudioBookingDTO = z.infer<
  typeof RehearsalStudioBookingSchema
>;

export const RehearsalSessionSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  performerId: z.string(),
  performerName: z.string().optional(),
  assignmentId: z.string().nullable(),
  roomBookingId: z.string().nullable().optional(),
  roomId: z.string().nullable().optional(),
  roomName: z.string().nullable().optional(),
  bookingStartTime: z.string().nullable().optional(),
  bookingEndTime: z.string().nullable().optional(),
  bookingStatus: z
    .enum(["scheduled", "completed", "cancelled"])
    .nullable()
    .optional(),
  scheduledDate: z.string(),
  location: z.string().nullable(),
  status: RehearsalSessionStatusSchema,
  notes: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type RehearsalSessionDTO = z.infer<typeof RehearsalSessionSchema>;

export const CreateRehearsalSessionSchema = z.object({
  performerId: z.string().min(1),
  scheduledDate: z.string().min(1),
  location: z.string().nullable().optional(),
  status: RehearsalSessionStatusSchema.optional(),
  notes: z.string().nullable().optional(),
  assignmentId: z.string().nullable().optional(),
  roomBookingId: z.string().nullable().optional(),
  studioBooking: RehearsalStudioBookingSchema.optional(),
});
export type CreateRehearsalSessionDTO = z.infer<
  typeof CreateRehearsalSessionSchema
>;

export const BulkCreateRehearsalSessionsSchema = z.object({
  performerIds: z.array(z.string().min(1)).min(1),
  scheduledDates: z.array(z.string().min(1)).min(1),
  location: z.string().nullable().optional(),
  status: RehearsalSessionStatusSchema.optional(),
  notes: z.string().nullable().optional(),
  studioBooking: RehearsalStudioBookingSchema.optional(),
});
export type BulkCreateRehearsalSessionsDTO = z.infer<
  typeof BulkCreateRehearsalSessionsSchema
>;

export const BulkRescheduleRehearsalSessionsSchema = z.object({
  fromScheduledDate: z.string().min(1),
  scheduledDate: z.string().min(1),
  studioBooking: RehearsalStudioBookingSchema.optional(),
});
export type BulkRescheduleRehearsalSessionsDTO = z.infer<
  typeof BulkRescheduleRehearsalSessionsSchema
>;

export const BulkUpdateRehearsalSessionStatusSchema = z.object({
  sessionIds: z.array(z.string().min(1)).min(1),
  status: RehearsalSessionStatusSchema,
});
export type BulkUpdateRehearsalSessionStatusDTO = z.infer<
  typeof BulkUpdateRehearsalSessionStatusSchema
>;

export const UpdateRehearsalSessionSchema = z.object({
  performerId: z.string().min(1).optional(),
  scheduledDate: z.string().min(1).optional(),
  location: z.string().nullable().optional(),
  status: RehearsalSessionStatusSchema.optional(),
  notes: z.string().nullable().optional(),
  assignmentId: z.string().nullable().optional(),
});
export type UpdateRehearsalSessionDTO = z.infer<
  typeof UpdateRehearsalSessionSchema
>;

export const RehearsalSessionParamSchema = z.object({
  eventId: z.string().min(1),
  sessionId: z.string().min(1),
});
